import React from 'react';

const Payslip = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '5px' }}>DEVANGLES</h1>
      <h2 style={{ textAlign: 'center', marginTop: '0', marginBottom: '20px' }}>DevAngles Software Pvt Ltd</h2>
      
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <tbody>
          <tr>
            <td colSpan="4" style={{ border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: '5px' }}>Salary Slip</td>
            <td style={{ border: '1px solid #000', textAlign: 'center', fontWeight: 'bold', padding: '5px' }}>Month</td>
            <td style={{ border: '1px solid #000', textAlign: 'center', padding: '5px' }}>Jan-2025</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Employee Name</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>Rajendra Prasad Yadav</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Total Calendar Days</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>31</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Designation</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>Software Engineer</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Number of Days Paid</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>29.5</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Date of Joining</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>1st Jul 2021</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>LOP days</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>1.5</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>PAN</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>ZDKVJ7541A</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Leaves</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>P | S</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Bank Account Number</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>XXXXXXXXXX1145</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Leave Opening Balance</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>4.5 | 3.5</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Bank Name</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>HDFC</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Leaves Taken</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>0 | 5</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000' }}></td>
            <td style={{ border: '1px solid #000' }}></td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px' }}>Leave Closing Balance</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>4.5 | -1.5</td>
          </tr>
        </tbody>
      </table>
      
      <hr style={{ borderTop: '1px solid #000', margin: '20px 0' }} />
      
      <h3 style={{ marginBottom: '10px' }}>Income</h3>
      
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <tbody>
          <tr>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px', width: '25%' }}>Particulars</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px', width: '25%' }}>Amount</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px', width: '25%' }}>Particulars</td>
            <td style={{ border: '1px solid #000', fontWeight: 'bold', padding: '5px', width: '25%' }}>Amount</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', padding: '5px' }}>Basic Salary</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>₹7,461.00</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>LOP</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>₹959.00</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', padding: '5px' }}>HRA</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>₹2,500.00</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>Professional Tax</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>₹200.00</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', padding: '5px' }}>Personal Allowance</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>₹9,852.00</td>
            <td style={{ border: '1px solid #000', padding: '5px' }}></td>
            <td style={{ border: '1px solid #000', padding: '5px' }}></td>
          </tr>
        </tbody>
      </table>
      
      <hr style={{ borderTop: '1px solid #000', margin: '20px 0' }} />
      
      <h3 style={{ marginBottom: '10px' }}>Total</h3>
      
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
        <tbody>
          <tr>
            <td style={{ border: '1px solid #000', padding: '5px', width: '50%', textAlign: 'right' }}>₹19,813.00</td>
            <td style={{ border: '1px solid #000', padding: '5px', width: '25%', fontWeight: 'bold' }}>Total</td>
            <td style={{ border: '1px solid #000', padding: '5px', width: '25%' }}>₹1,159.00</td>
          </tr>
          <tr>
            <td style={{ border: '1px solid #000', padding: '5px', fontWeight: 'bold' }}>Net Salary</td>
            <td style={{ border: '1px solid #000' }}></td>
            <td style={{ border: '1px solid #000', padding: '5px' }}>₹18,654.00</td>
          </tr>
        </tbody>
      </table>
      
      <hr style={{ borderTop: '1px solid #000', margin: '20px 0' }} />
      
      <p style={{ textAlign: 'center', fontStyle: 'italic' }}>Eighteen Thousand Six Hundred Fifty Four</p>
    </div>
  );
};

export default Payslip;